// 页面样式
import css from 'css/page/finesse.scss'

// 公共方法
import {
  domObserver,
  headerInit,
  memberShip,
} from 'js/common/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts () {
  memberFormInit()
  jumpToGame()
}

/**
 * 登录相关表单事件初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 攻略卡片点击游戏名跳转游戏主页，点击卡片其他位置跳转攻略页
 */
function jumpToGame () {
  $('.sec-main .list').on('click', 'li a', handler)

  function handler (e) {
    e.preventDefault()
    window.location.href = e.target.nodeName.toLowerCase() === 'span' && $(e.target).hasClass('link') ? e.target.getAttribute('href') : this.getAttribute('href')
  }
}

/**
 * UI 初始化
 */
function uiInit () {
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})



// WEBPACK FOOTER //
// ./js/page/finesse.js